import { Client, Account, Databases, Functions, Storage, Locale } from 'appwrite';

// Appwrite client singleton configured from Vite env vars
const endpoint = import.meta.env.VITE_APPWRITE_ENDPOINT as string;
const projectId = import.meta.env.VITE_APPWRITE_PROJECT_ID as string;

export const client = new Client();
client.setEndpoint(endpoint).setProject(projectId);

// Expose core SDK services
export const account = new Account(client);
export const databases = new Databases(client);
export const functions = new Functions(client);
export const storage = new Storage(client);
export const locale = new Locale(client); // public, no auth required; good for console connectivity

// Helper to verify configuration at runtime
export const assertAppwriteConfigured = () => {
  if (!endpoint || !projectId) {
    console.warn('Appwrite not configured: set VITE_APPWRITE_ENDPOINT and VITE_APPWRITE_PROJECT_ID');
  }
};

// Quick diagnostics to help align with Appwrite React quick-start
export const getEnvDiagnostics = () => {
  const ep = import.meta.env.VITE_APPWRITE_ENDPOINT as string;
  const pid = import.meta.env.VITE_APPWRITE_PROJECT_ID as string;
  const dbId = import.meta.env.VITE_APPWRITE_DB_ID as string;
  const sessionsId = import.meta.env.VITE_APPWRITE_SESSIONS_COLLECTION_ID as string;
  const tradesId = import.meta.env.VITE_APPWRITE_TRADES_COLLECTION_ID as string;
  const usersId = import.meta.env.VITE_APPWRITE_USERS_COLLECTION_ID as string;
  const authEventsId = import.meta.env.VITE_APPWRITE_AUTH_EVENTS_COLLECTION_ID as string;
  const normalized = (ep || '').replace(/\/+$/, '');
  const endpointValidFormat = /^https:\/\/[a-z]+\.cloud\.appwrite\.io\/v1$/.test(normalized);
  const regionMatch = normalized.match(/^https:\/\/([a-z]+)\.cloud\.appwrite\.io/);
  const region = regionMatch?.[1] ?? null;
  return {
    hasEndpoint: !!ep,
    hasProjectId: !!pid,
    endpointValidFormat,
    region,
    hasDbId: !!dbId,
    hasSessionsCollectionId: !!sessionsId,
    hasTradesCollectionId: !!tradesId,
    hasUsersCollectionId: !!usersId,
    hasAuthEventsCollectionId: !!authEventsId,
  };
};

export default client;